

export default {
    install(Vue) {
        Vue.filter('countryFilter', function (value) {
            if (value == 'CANADA')
                return 'Canada'
            if (value == 'US')
                return 'US'
            return value
        })
    }
};
